function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD15D"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M499.683,334.619l-98.444-98.444l-92.951,21.968l-68.579-68.577l-110.571,78.37l82.535,82.535 l142.155,142.153C422.812,464.074,476.591,406.24,499.683,334.619z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#324A5E"
    },
    points: "401.239,236.175 193.102,236.175 239.711,189.566 211.673,161.528 117.201,256  211.673,350.472 239.711,322.434 193.102,275.825 401.239,275.825 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2B3B4E"
    },
    points: "401.239,257.15 118.351,257.15 211.673,350.472 239.711,322.434 193.102,275.825  401.239,275.825 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.4cf51c929b9d57c2aedff69d2a7a73e3.svg";
export { ForwardRef as ReactComponent };